import { Box, Button, Form, IconButton, Textarea } from '@zillow/constellation-10';
import { IconAttachmentOutline } from '@zillow/constellation-icons';
import SkeletonContainer from '../SkeletonContainer';

const Skeleton = (): JSX.Element => {
  return (
    <SkeletonContainer>
      <Form
        css={{
          borderTop: '1px solid',
          borderTopColor: 'border.subtle',
          padding: 'default',
        }}
      >
        <Textarea
          rows={1}
          disabled={true}
          placeholder="Write message..."
          css={{ backgroundColor: 'bg.neutral', boxShadowColor: 'bg.neutral' }}
        />

        <Box css={{ display: 'flex', alignItems: 'center', flexDirection: 'row', marginTop: 'tighter', width: '100%' }}>
          <IconButton
            disabled={true}
            emphasis="bare"
            icon={<IconAttachmentOutline />}
            shape="circle"
            size="md"
            title="Attach files or images"
            tone="neutral"
          />

          <Box css={{ display: 'flex', justifyContent: 'flex-end', width: '100%', position: 'relative' }}>
            <Button emphasis="filled" disabled={true} tone="brand">
              Send
            </Button>
          </Box>
        </Box>
      </Form>
    </SkeletonContainer>
  );
};

export default Skeleton;
